import clsx from "clsx";
import { useAtom } from "jotai";
import { useMemo } from "react";

import { QuizProgressBar } from "../../../shared/components/lander-quiz-components/quiz-progress-bar/quiz-progress-bar.component";
import { LANDER_QUIZ_EXTRA_ENTRIES } from "../../lander-quiz.constants";
import {
  branchedQuestionsCountAtom,
  currentQuestionIndexAtom,
  landerQuizAtom,
} from "../../lander-quiz.state";
import { LanderQuizQuestionTypeEnum } from "../../lander-quiz.types";

export const LanderQuizHeader: React.FC = () => {
  const [landerQuiz] = useAtom(landerQuizAtom);
  const [currentQuestionIndex] = useAtom(currentQuestionIndexAtom);
  const [branchedQuestionsCount] = useAtom(branchedQuestionsCountAtom);

  const questionsAnsweredCount = useMemo(
    () =>
      landerQuiz.questions.filter((question) => {
        if (question.type === LanderQuizQuestionTypeEnum.MultiOptionGrid) {
          return !!question.answer && question.answer.split(",").length > 1;
        }
        return !!question.answer;
      }).length,
    [landerQuiz]
  );

  return (
    <div className="lander__quiz__header">
      <div
        className={clsx(
          "lander__quiz__header--title",
          currentQuestionIndex === 0 && "first-question"
        )}
      >
        {currentQuestionIndex === 0 ? (
          <>
            Get +{LANDER_QUIZ_EXTRA_ENTRIES} extra entries by <br />
            answering a quick survey:
          </>
        ) : (
          <>
            Complete the survey to secure +{LANDER_QUIZ_EXTRA_ENTRIES} extra
            entries.
          </>
        )}
      </div>
      <QuizProgressBar
        branchedQuestionsCount={branchedQuestionsCount}
        quizQuestionsCount={landerQuiz.questions.length}
        questionsAnsweredCount={questionsAnsweredCount}
      />
    </div>
  );
};
